import { render, staticRenderFns } from "./FakePayment.vue?vue&type=template&id=6643b080"
import script from "./FakePayment.vue?vue&type=script&lang=js"
export * from "./FakePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports